import { render, staticRenderFns } from "./download-view.vue?vue&type=template&id=def98e72&scoped=true&"
import script from "./download-view.vue?vue&type=script&lang=js&"
export * from "./download-view.vue?vue&type=script&lang=js&"
import style0 from "./download-view.vue?vue&type=style&index=0&id=def98e72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def98e72",
  null
  
)

export default component.exports